import React from "react";
import PropTypes from "prop-types";
import styles from "./LandingTabs.module.scss";

/**
 * Renders top-level tabs for landing navigation.
 * Tabs without click handlers are shown as disabled design placeholders.
 */
const LandingTabs = ({ tabs, activeTabId = "" }) => {
  const visibleTabs = tabs.filter((tab) => tab.visible !== false);

  return (
    <div className={styles.tabsBar} role="tablist" aria-label="Landing tabs">
      {visibleTabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        const isDisabled = !tab.onClick;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-disabled={isDisabled}
            className={`${styles.tabButton} ${isActive ? styles.tabActive : ""} ${
              isDisabled ? styles.tabDisabled : ""
            }`}
            onClick={() => {
              if (!isDisabled) {
                tab.onClick();
              }
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

LandingTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      visible: PropTypes.bool,
    })
  ).isRequired,
  activeTabId: PropTypes.string,
};

export default LandingTabs;
